// Order of cab categories on the Fares and Categories pages. A category not named here (a newly added
// one) goes FIRST, in the order the API sent it, then the categories below follow in this order.
// A leading "Him " is ignored when matching, so "HIM QUICK" is
// "quick", "Him Cab Mini Bus" is "cab mini bus" and "Him Shuttle" is "shuttle".
// Production: HIM QUICK, Standard, Economy, Luxury, Premium, Him Cab Mini Bus.
// Staging: Standard, Comfort, Family, Premium, Shuttle. Both fit this one list.
export const CATEGORY_ORDER = [
  "quick",
  "standard",
  "economy",
  "luxury",
  "comfort",
  "family",
  "premium",
  "cab mini bus",
  "shuttle",
];

export const categoryRank = (name?: string) => {
  const key = (name ?? "").trim().toLowerCase().replace(/^him\s+/, "");
  const rank = CATEGORY_ORDER.indexOf(key);
  return rank; // -1 for a category not in the list, so it sorts ahead of the listed ones
};
